import React, { useState } from 'react'
import { Input, Popconfirm } from 'antd'
import {
  DeleteFilled,
  SaveFilled,
  EditFilled,
  LoadingOutlined,
  RedoOutlined,
  QuestionCircleOutlined,
  CloseOutlined,
} from '@ant-design/icons'
import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { Horizontal, Texto, Vertical, GraviButton } from '@gravitate-js/excalibrr'

export const BackhaulEditButtons = ({ cancelOrder, resetOrder, showOrderResetBtn, optimizing }) => {
  const { isEditingBackhaul } = useWizardMaster()
  const { scopes } = useSecurityContext()
  if (optimizing) return null
  const canEditOrder = scopes?.create_order

  if (isEditingBackhaul && canEditOrder) {
    return <EditingButtons canEditOrder={canEditOrder} />
  } else {
    return (
      <DefaultButtons
        cancelOrder={cancelOrder}
        canEditOrder={canEditOrder}
        resetOrder={resetOrder}
        showOrderResetBtn={showOrderResetBtn}
      />
    )
  }
}
const DefaultButtons = ({ cancelOrder, canEditOrder, resetOrder, showOrderResetBtn }) => {
  const { wizardOrder, setIsEditingBackhaul, isComplete } = useWizardMaster()
  const orderState = wizardOrder.state
  const showReset = orderState === 'in progress'
  const [note, setNote] = useState('')

  const CancelOrderConfirmation = (
    <Vertical>
      <Vertical className={'p2'} flex={1}>
        <Texto> Are you sure? </Texto>
        <Texto> Once an order is canceled, it cannot be reverted.</Texto>
      </Vertical>
      <Horizontal flex={1} className={'pt-2'}>
        <Input placeholder='Add a note' allowClear onChange={(e) => setNote(e.target.value)} value={note} />
      </Horizontal>
    </Vertical>
  )
  return (
    <>
      {canEditOrder && (
        <GraviButton
          size='large'
          theme2
          buttonText='Edit Details'
          onClick={() => {
            setIsEditingBackhaul(true)
          }}
          icon={<EditFilled />}
        />
      )}
      {canEditOrder && orderState === 'accepted' && (
        <Popconfirm
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          title={CancelOrderConfirmation}
          onConfirm={() => cancelOrder(isComplete, note)}
          okText='Yes'
          cancelText='No'
        >
          <GraviButton
            size='large'
            error
            appearance='outlined'
            icon={<DeleteFilled />}
            buttonText='Cancel Order'
            onClick={() => cancelOrder(isComplete, note)}
          />
        </Popconfirm>
      )}
      {canEditOrder && showReset && (
        <Popconfirm
          title='Are you sure to reset this order? This will remove all driver information logged.'
          onConfirm={() => resetOrder(isComplete)}
          okText='Yes'
          cancelText='No'
        >
          {showOrderResetBtn && (
            <GraviButton
              size='large'
              error
              appearance='outlined'
              icon={<RedoOutlined />}
              buttonText='Reset Order'
              onClick={() => resetOrder(isComplete)}
            />
          )}
        </Popconfirm>
      )}
    </>
  )
}
const EditingButtons = ({ canEditOrder }) => {
  const { setIsEditingBackhaul, isSaving, saveBackhaul } = useWizardMaster()

  return (
    <>
      <GraviButton
        size='large'
        error
        appearance='outlined'
        icon={<CloseOutlined />}
        buttonText='Cancel Changes'
        onClick={() => {
          setIsEditingBackhaul(false)
        }}
        extraClass='cancel'
      />

      {canEditOrder && (
        <GraviButton
          size='large'
          theme2
          icon={isSaving ? <LoadingOutlined spin /> : <SaveFilled />}
          buttonText='Save Changes'
          onClick={() => saveBackhaul()}
          extraClass='save'
        />
      )}
    </>
  )
}
